import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import PageHero from '../../components/feature/sections/PageHero';
import TrustBar from '../../components/feature/sections/TrustBar';
import CompanyOverview from './components/CompanyOverview';
import AIAnswerBlock, { AIAnswerItem } from '../../components/feature/sections/AIAnswerBlock';
import ProcessSection from '../../components/feature/sections/ProcessSection';
import WhyChooseUs from '../../components/feature/sections/WhyChooseUs';
import ServiceAreas from '../../components/feature/sections/ServiceAreas';
import Testimonials from '../../components/feature/sections/Testimonials';
import FAQSection, { FAQItem } from '../../components/feature/sections/FAQSection';
import FinalCTA from '../../components/feature/sections/FinalCTA';

const aiItems: AIAnswerItem[] = [
  {
    question: 'Who is Value Carpet Inc?',
    answer: 'Value Carpet Inc is a specialty flooring company based in Freehold, New Jersey, specializing in professional installation services for both residential and commercial clients. They focus on high-quality workmanship and dependable service across every project.',
  },
  {
    question: 'What does Value Carpet Inc specialize in?',
    answer: 'Value Carpet Inc specializes in carpet installation, hardwood flooring, laminate, vinyl, marine-grade carpet, carpet tiles, and specialty turf — serving residential homeowners and commercial businesses across New Jersey.',
  },
  {
    question: 'Who does Value Carpet Inc serve?',
    answer: 'They serve residential homeowners, property managers, and commercial businesses across Monmouth County, Ocean County, and surrounding central New Jersey communities — from single-room installs to large commercial flooring projects.',
  },
  {
    question: 'Why choose a local flooring company in New Jersey?',
    answer: 'Local flooring companies provide personalized service, faster response times, and a stronger understanding of regional homes and building types. Value Carpet Inc brings local expertise and community accountability to every project they complete.',
  },
];

const faqs: FAQItem[] = [
  {
    q: 'How long has Value Carpet Inc been in business?',
    a: 'Value Carpet Inc is an established flooring specialist based in Freehold, NJ. Their team brings hands-on experience across residential and commercial flooring projects of all sizes throughout New Jersey.',
  },
  {
    q: 'Is Value Carpet Inc licensed and insured?',
    a: 'Yes. Value Carpet Inc is fully licensed and insured, providing professional flooring services with the credentials and accountability you expect from a trusted local contractor in New Jersey.',
  },
  {
    q: 'Why choose a local flooring company over a big box retailer?',
    a: 'Local flooring specialists like Value Carpet Inc offer personalized attention, expert guidance, and accountability that big box retailers cannot match. You get a dedicated team invested in quality outcomes — not just a transaction.',
  },
  {
    q: 'Does Value Carpet Inc handle both residential and commercial projects?',
    a: 'Yes. Value Carpet Inc serves both residential homeowners and commercial clients across New Jersey — from bedroom carpet installs to large-scale commercial flooring projects requiring carpet tiles and specialty materials.',
  },
  {
    q: 'How do I get a flooring quote from Value Carpet Inc?',
    a: 'Contact Value Carpet Inc directly via phone at 1-866-732-2966, email at sales@valuecarpetinc.com, or fill out the consultation form. They respond within minutes during business hours and provide free, no-obligation quotes.',
  },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-cream font-sans">
      <Navbar />
      <main>
        <PageHero
          title="About Value Carpet Inc"
          subtitle="Dedicated to quality flooring and reliable service — for residential homeowners and commercial businesses across New Jersey."
          tag="About Us · Freehold, NJ"
          imageSrc="https://public.readdy.ai/ai/img_res/8f560a651037efe264528dc1657cec89.jpg"
          imageAlt="About Value Carpet Inc — Professional flooring specialists"
        />
        <TrustBar />
        <CompanyOverview />
        <AIAnswerBlock title="About Value Carpet Inc — Explained" items={aiItems} />
        <ProcessSection />
        <WhyChooseUs />
        <ServiceAreas />
        <Testimonials />
        <FAQSection title="About Value Carpet — FAQs" faqs={faqs} />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
